import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Checkbox, Form, Input } from "antd";
import Link from "antd/es/typography/Link";
import Navbar from "../components/Navbar";
import { loginUser, registerUser } from "../redux/reducer";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Div = styled.div`
  height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;


const ProgressBar = styled.div`
  position: absolute;
  margin-top: 50vh;
  margin-left: 50vw;
`;


const Title=styled.div`
  padding-top: 50px;
  color:  green;
  font-size: xx-large;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LogReg = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userName);
  const navigate = useNavigate();

  const [isOpen, setIsopen] = useState(false);
  const [isRegister, setIsRegister] = useState(true);
  const [sign, setSign] = useState("login");
  const [isModalOpen, setIsModalOpen] = useState(false);


  const login = async (values) => {
    setIsModalOpen(true);
    
    const res = await axios.post("https://e-learning-ewv6.onrender.com/logreg/login", values);
    console.log(res)
    if(res.data.error)
        alert(res.data.error)
    else
        dispatch(loginUser(res.data.others.username));
    setIsModalOpen(false);
  };

  const register = async (values) => {
    setIsModalOpen(true);

    const res = await axios.post(
      "https://e-learning-ewv6.onrender.com/logreg/register",
      values
    );
    console.log(res)
    if(res.data.error)
      alert(res.data.error)
    else
      dispatch(registerUser(res.data.others.username));
    setIsModalOpen(false);

  };

  const toggle = () => {
    setIsRegister(!isRegister);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = async (values) => {
    if (isRegister) await register(values);
    else await login(values);
  };

  useEffect(() => {
    if (user) navigate("/");
  }, [user]);

  useEffect(() => {
    if (user) navigate("/");
  }, []);

  return (
    <Container>
     <Title>
        Welcome to E- Learning
     </Title>

     <Modal open={isModalOpen}>
        <ProgressBar>
          <CircularProgress style={{ color: "white" }} />
        </ProgressBar>
      </Modal>

      <Div>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          {isRegister && (
            <Form.Item
              label="Username"
              name="username"
              rules={[
                {
                  required: isRegister ? true : false,
                  message: "Please input your username!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          )}

          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                type: "email",
                required: true,
                message: "Please input your valid email!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              {isRegister ? "Register" : "Login"}
            </Button>
            <Link
              type="link"
              style={{ color: "blue", position: "absolute", right: "5px" }}
              onClick={() => setIsRegister(!isRegister)}
              htmlType="submit"
            >
              {isRegister ? "Login?" : "Register?"}
            </Link>
          </Form.Item>
        </Form>
      </Div>
    </Container>
  );
};

export default LogReg;
